import { InvestorSignAgreement } from './InvestorSignAgreement'
import { useNavigate } from 'react-router-dom'

function InvestorSignatureContent() {
  const navigate = useNavigate()
  return (
    <InvestorSignAgreement
      onContractSigned={async () => {
        navigate('/account')
      }}
    />
  )
}

export { InvestorSignatureContent }
